import { render, staticRenderFns } from "./ReviewPopup.vue?vue&type=template&id=532cd962&scoped=true"
import script from "./ReviewPopup.vue?vue&type=script&lang=js"
export * from "./ReviewPopup.vue?vue&type=script&lang=js"
import style0 from "./ReviewPopup.vue?vue&type=style&index=0&id=532cd962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532cd962",
  null
  
)

export default component.exports